import StatusBarWrapper from "@components/Layouts/StatusBar/StatusBarWrapper";
import useIsOverflow from "@core-ui/hooks/useIsOverflow";
import styled from "@emotion/styled";
import type GitBranchData from "@ext/git/core/GitBranch/model/GitBranchData";
import t from "@ext/localization/locale/translate";
import { useRef } from "react";
import SpinnerLoader from "../../../../../components/Atoms/SpinnerLoader";

interface BranchProps {
	branch: GitBranchData;
	show: boolean;
	onClick?: () => void;
	disable?: boolean;
}

const BranchName = styled.span`
	display: inline-block;
	max-width: 100%;
	overflow: hidden;
	text-overflow: ellipsis;
	vertical-align: bottom;
`;

const TooltipName = styled.span`
	word-break: break-all;
`;

const Branch = ({ branch, show, onClick, disable }: BranchProps) => {
	const branchName = branch?.name;
	const nameRef = useRef<HTMLSpanElement>(null);
	const isOverflow = useIsOverflow(nameRef, [branchName]);

	return (
		<StatusBarWrapper
			additionalStyles={{ overflow: "hidden" }}
			dataQa="qa-branch"
			disable={disable}
			iconCode="git-branch"
			iconStyle={{ color: show ? "var(--color-primary)" : "white" }}
			isShow={show}
			onClick={onClick}
			tooltipText={
				isOverflow && branchName ? <TooltipName>{branchName}</TooltipName> : t("git.branch.management")
			}
		>
			<BranchName ref={nameRef}>{branchName ? branchName : <SpinnerLoader height={12} width={12} />}</BranchName>
		</StatusBarWrapper>
	);
};

export default Branch;
